import { Header, Icon, Segment } from 'semantic-ui-react';

export default function InvalidResident() {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
                Invalid link.  The link may have expired.
            </Header>            
        </Segment>
    )
}